/**
 * Flags de despliegue del front.
 *
 * Se leen de variables `REACT_APP_*`, que CRA hornea EN TIEMPO DE BUILD: no
 * basta con reiniciar el proceso, hay que reconstruir (o relanzar el dev
 * server) para que un cambio surta efecto.
 *
 * Criterio: opt-in EXPLÍCITO. Si la variable no está definida, la función queda
 * OCULTA. Producción no define ninguna de estas, así que un entorno nuevo nunca
 * estrena por accidente algo que todavía no está listo; encenderlo es siempre
 * un acto deliberado del entorno que lo quiere.
 */

/**
 * Kanban de tickets (`/admin/tickets`), respaldado por microservice-tickets.
 *
 * Apagado en producción a propósito: su API (`REACT_APP_TICKETS_API`) apunta
 * hoy a una dirección de LAN, así que publicarlo dejaría un tablero que no
 * carga para nadie fuera de la red interna. La tickera vieja de
 * `/admin/incidents` sigue siendo la puerta de apelaciones mientras tanto.
 *
 * Se enciende en el servidor de QA con `REACT_APP_TICKETS_ENABLED=true` en su
 * `.env.local` (que está fuera de git, y por eso el flag no viaja al repo).
 *
 * Apaga las dos puertas de entrada a la vez —el ítem del sidebar y la RUTA—,
 * porque ocultar solo el menú dejaría el tablero alcanzable escribiendo la URL.
 */
export const TICKETS_ENABLED = process.env.REACT_APP_TICKETS_ENABLED === "true";

/**
 * Vía puente de Shopify: el comercio pega `client_id` + `client_secret` de una
 * app que creó en SU Dev Dashboard (AddShopifyModal → direct-credentials).
 *
 * Con la app pública "Beartrack App" aprobada en el Shopify App Store, todo
 * comercio NUEVO conecta por ahí. Esta vía queda solo como palanca de soporte
 * para re-alta o rotación de credenciales de tiendas YA vinculadas por el
 * puente: el backend rechaza con 403 cualquier tienda nueva, así que mostrarla
 * a todos solo produciría altas que fallan al final del formulario.
 *
 * Apagado por defecto: la guía de la app oficial no ofrece el enlace a
 * credenciales. Se enciende con `REACT_APP_SHOPIFY_DIRECT_ENROLL=true` en el
 * build del entorno que lo necesite.
 */
export const SHOPIFY_DIRECT_ENROLL_ENABLED =
  process.env.REACT_APP_SHOPIFY_DIRECT_ENROLL === "true";

/**
 * Vista "Atención e incidencias" (`/admin/helpdesk/incidencias`): bandeja de la
 * mesa de ayuda, chat y panel de incidencias y paquetes en una sola pantalla.
 *
 * Apagada hasta que estén en producción los contratos de backend de los que
 * depende (filtro de incidencias abiertas, búsqueda de paquetes por teléfono,
 * origen e idempotencia del alta y nota de sistema en la conversación): sin
 * ellos el panel contaría mal o un reintento del alta duplicaría la incidencia.
 *
 * Igual que TICKETS_ENABLED, apaga a la vez el ítem del sidebar y la RUTA. Se
 * fija en el build: apagarla exige reconstruir y desplegar.
 */
export const HELPDESK_INCIDENTS_ENABLED =
  process.env.REACT_APP_HELPDESK_INCIDENTS_ENABLED === "true";
